<template>
    <mdb-container fluid v-if="productGroup">
        <h1>{{ productGroup.name }}</h1>
        <h3 class="mb-4" v-if="productGroup.description">{{ productGroup.description }}</h3>

        <ul class="list-group">
            <div class="list-group-item" v-for="item in productGroup.files" :key="item.id">
                <div v-if="item.components_data_media_id.media_file" class="d-flex align-items-center">
                  <download-icon-link :uri="item.components_data_media_id.media_file" :name="item.components_data_media_id.title" class="text-white btn-floating btn-primary btn-sm flex-shrink-0" />
                  {{ item.components_data_media_id.title }}
                </div>
                <div v-else class="d-flex align-items-center">
                    <a class="text-white btn-floating btn-danger btn-sm flex-shrink-0" ><mdb-icon class="mr-2" icon="file-download" /></a>
                    <span>
                        {{ item.components_data_media_id.title }}
                    </span>
                </div>
            </div>
        </ul>

        <hr class="mb-5">

        <section>
            <mdb-row>
                <mdb-col xl="3" md="6" class="mb-4" v-for="product in productGroup.products" :key="product.id" >
                    <mdb-card class="card-body d-flex h-100 flex-column justify-content-between" >
                        <h5>{{ product.name }}</h5>
                        <div class="flex-row">
                            <router-link class="btn btn-primary" :to="'/products/' + product.id">Подробнее</router-link>
                        </div>
                    </mdb-card>
                </mdb-col>
            </mdb-row>
        </section>

    </mdb-container >
</template>

<script>

    import axios from 'axios'
    import {
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbIcon

    } from "mdbvue";
    import store from "../../store";
    import DownloadIconLink from "../link/DownloadIconLink.vue";
    export default {
        name: "group",
        components: {
          DownloadIconLink,
            mdbContainer,
            mdbRow,
            mdbCol,
            mdbCard,
            mdbIcon
        },
        data() {
            return {
                groupID: this.$route.params.id,
                productGroup: null,
                contentBase: process.env.VUE_APP_CONTENT_2_URL,
                token: process.env.VUE_APP_CONTENT_2_REST_TOKEN
            }
        },
        watch: {
            $route() {
                axios.get(process.env.VUE_APP_CONTENT_2_URL + '/items/product_group/' + this.$route.params.id + '?fields=*.*.*&access_token=' + process.env.VUE_APP_CONTENT_2_REST_TOKEN, {headers:{Authorization: ''}})
                    .then(response => {
                        this.productGroup = response.data.data
                        store.commit('setBreadcrumbs',['Страховая документация', this.productGroup.name]);
                    });
            }
        },
        mounted() {
            axios.get(process.env.VUE_APP_CONTENT_2_URL + '/items/product_group/' + this.$route.params.id + '?fields=*.*.*&access_token=' + process.env.VUE_APP_CONTENT_2_REST_TOKEN, {headers:{Authorization: ''}})
                .then(response => {
                    this.productGroup = response.data.data;
                    console.log(response);
                    store.commit('setBreadcrumbs',['Страховая документация', this.productGroup.name]);
                });
        },
    }
</script>

<style scoped>

</style>